





















import {
  Vue,
  Component,
  Prop,
  Watch,
} from "@/shared/vuepack";
import { Location } from "vue-router";
import TabGroup from "@/shared/components/ui/TabGroup.vue";
import Tab from "@/shared/components/ui/Tab.vue";
import ContributionSchedulesTable from "@/shared/components/contributionsV3/ContributionSchedulesTable.vue";
import { PersonalContributionSchedule } from "@/shared/types";
import { useBankAccountStore } from "@/employee/store/bankAccount";
import { usePersonalContributionSchedulesStore } from "@/shared/store/personalContributionSchedules";
import ContributionsActivity from "@/shared/components/contributionsV3/ContributionsActivity.vue";

@Component ({
  components: {
    ContributionsActivity,
    TabGroup,
    Tab,
    ContributionSchedulesTable
  }
})
export default class ContributionScheduleTabs extends Vue {
  bankAccountStore = useBankAccountStore();
  contributionSchedulesStore = usePersonalContributionSchedulesStore();

  @Prop()
  schedulesPage: number;

  @Prop()
  activityPage: number;

  @Prop()
  tab: string;

  @Prop()
  routeToModifySchedule: (schedule: PersonalContributionSchedule) => Location;

  @Prop({required: false})
  username: string;

  @Prop({required: false})
  partnerId: number;

  @Prop()
  futureContributionsPage: number;

  mounted (): void {
    this.bankAccountStore.loadLinkedBankAccounts();

    const args = { username: this.username, partnerId: this.partnerId };
    this.contributionSchedulesStore.getPersonalContributionSchedules(args);
    this.contributionSchedulesStore.getFutureContributions(args);

    this.$on("tab-clicked", (event, tab) => {
      this.handleTabChange(tab.type);
    });
  }

  get isLoaded (): boolean {
    return this.contributionSchedulesStore.schedulesLoaded && this.bankAccountStore.linkedAccountsLoaded &&
      this.contributionSchedulesStore.isFutureContributionsLoaded;
  }

  handleTabChange (filter): void {
    this.$router.push({query: {...this.$route.query, tab: filter}});
  }

  @Watch("contributionSchedulesStore.schedulesLoaded")
  reload (value) {
    if (!value && !this.contributionSchedulesStore.schedulesLoading) {
      const args = { username: this.username, partnerId: this.partnerId };
      this.contributionSchedulesStore.getPersonalContributionSchedules(args);
    }
  }

  @Watch("schedulesPage")
  loadPage () {
    this.contributionSchedulesStore.setSchedulesPage(this.schedulesPage);
  }
}
